import { TypedDocumentNode, gql } from '@apollo/client';
import { faDash } from '@fortawesome/pro-solid-svg-icons';
import { FormattedNumber } from 'react-intl';

import { AveragePlayerScore } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { BodyS } from '@sorare/core/src/atoms/typography';

import { Cell } from 'components/benchObject/BenchObjectTable/ui';

import { BreakdownPlayerScoreCell_anyPlayer } from './__generated__/index.graphql';

type Props = {
  anyPlayer: BreakdownPlayerScoreCell_anyPlayer;
  breakdown: AveragePlayerScore;
};

export const BreakdownPlayerScoreCell = ({ breakdown, anyPlayer }: Props) => {
  const value = (() => {
    switch (breakdown) {
      case AveragePlayerScore.LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE:
        return anyPlayer.lastFifteenAverageAllAroundScore;
      case AveragePlayerScore.LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE:
        return anyPlayer.lastFifteenAverageDecisiveScore;
      default:
        return null;
    }
  })();

  return (
    <Cell>
      <BodyS bold>
        {value === null ? (
          <FontAwesomeIcon icon={faDash} color="var(--c-nd-500)" />
        ) : (
          <FormattedNumber
            value={value}
            style="decimal"
            minimumFractionDigits={0}
            maximumFractionDigits={1}
          />
        )}
      </BodyS>
    </Cell>
  );
};

BreakdownPlayerScoreCell.fragments = {
  anyPlayer: gql`
    fragment BreakdownPlayerScoreCell_anyPlayer on AnyPlayerInterface {
      slug
      lastFifteenAverageAllAroundScore: averageScore(
        type: LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE
      )
      lastFifteenAverageDecisiveScore: averageScore(
        type: LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE
      )
    }
  ` as TypedDocumentNode<BreakdownPlayerScoreCell_anyPlayer>,
};
